// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container__3ZqYr","preTitle":"Tags_preTitle__1geg8","bonusButtons":"Tags_bonusButtons__3TZQo","bonusButton":"Tags_bonusButton__2OCJt","dates":"Tags_dates__2rrgw"};